import {
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE, COPIED_TEXT, LINK,
    NO_QR_CODE_OR_POLL_CODE_TO_SHARE, POLL_SHARE_MODE, POLL_TEXT,
    POLL_TYPE, SHARE_POLL_BUTTON_DISABLED_TOOLTIP_TEXT,
    SHARE_TEXT, SYNC_LMS_OPTIONS,
    UNIQUECODE_TEXT
} from "../../utils/constants";
import classes from "./ReleaseActivityPage.module.css";
import React, {useEffect, useState} from "react";
import {ReactComponent as COPY_LINK_ICON} from "./images/copy_link_icon.svg";
import {ReactComponent as SHARED_ICON} from "../../images/share_black.svg";
import {ReactComponent as QR_ICON} from "./images/QR_code_icon.svg";
import {ReactComponent as COPY_ICON} from "../../images/copy_gray.svg";

import {deCapitalizeWord, findFirstOverflowParent, generateUUID, notifySuccess} from "../../utils/helpers";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import YuJaButton from "../../components/standardization/YuJaButton";
import {QRCodeCanvas}  from "qrcode.react";
import {useParams} from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";
import {CLIPBOARD_COPY_SUCCESS} from "../../utils/toast-message-constants";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {useConfig} from "../../hooks/useConfig";


export default function ViewActivityShareButton({pollData}) {
    const { pollKey, pollCode } = useParams();
    let windowDimensions = useWindowDimensions();
    const config = useConfig();


    const {poll = {}, questions = []} = pollData;

    const { pollType} = poll;

    const {getRedirectUrl} = useSynLMSConfiguration();

    const [cardOpen, setCardOpen] = useState(false);
    const [randomId, ] = useState(() => generateUUID());
    const [QRCodeImageURL, setQRCodeImageURL] = useState("");
    const [copied, setCopied] = useState(false);


    const btnStyle = {width: 200, height: 35, display: "flex", alignItems: "center", justifyContent: "center"};

    const hostname = window.location.hostname;
    let shortName = '';
    if (hostname.includes(config.host_url) && hostname.includes("www")) {
        shortName = hostname.indexOf('.') >= 0 ?
            hostname.substring(hostname.indexOf('.') + 1, hostname.indexOf("engage.yuja.com") - 1) :
            hostname;
    } else {
        shortName = hostname.indexOf('.') >= 0 ?
            hostname.substring(0, hostname.indexOf('.')) :
            hostname;
    }



    const setPosition = () => {
        let trigger = document.querySelector(`[data-yuja-share-trigger-id='${randomId}']`);
        let card = document.querySelector(`[data-yuja-share-card-id='${randomId}']`);

        if (!trigger || !card) {
            return;
        }


        let parent = findFirstOverflowParent(trigger);
        const {left: parentLeft } = parent.getBoundingClientRect();


        const {left, width, height, top, } = trigger.getBoundingClientRect();
        const {width: cardWidth,  } = card.getBoundingClientRect();
        if (left - cardWidth > parentLeft) { // left
            // card.style.transform =  `translate(${Math.round(left + width - cardWidth)}px, ${top + height + 5}px)`;
            card.style.left = `${Math.round(left + width - cardWidth)}px`;
            card.style.top = `${top + height + 5}px`;
        } else {
            card.style.left = `${Math.round(left)}px`
            card.style.top = `${top + height + 5}px`
            // card.style.transform =  `translate(${Math.round(left)}px, ${top + height + 5}px)`;
        }



    }


    // useEffect(() => {
    //     if (infoCardOpen) {
    //         document.addEventListener('scroll', setPosition, true);
    //         setPosition();
    //     }
    //
    //     return () => {
    //         document.removeEventListener('scroll', setPosition)
    //     };
    // }, [infoCardOpen, windowDimensions, randomId]);


    useEffect(() => {
        const handleGlobalClick = (event) => {
            let card = document.querySelector(`[data-yuja-share-card-id='${randomId}']`);
            let trigger = document.querySelector(`[data-yuja-share-trigger-id='${randomId}']`);
            if (cardOpen && (!card || !card.contains(event.target)) && (!trigger || !trigger.contains(event.target))) {
                setCardOpen(false);
            }
        };

        if (cardOpen) {
            setPosition();
            document.addEventListener('click', handleGlobalClick, true);
        }
        return () => {
            document.removeEventListener('click', handleGlobalClick)
        };
    }, [cardOpen, windowDimensions]);






    const downloadQR = () => {
        let downloadLink = document.createElement("a");
        downloadLink.href = QRCodeImageURL;
        downloadLink.download = `${pollCode}.png`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };


    useEffect(() => {
        if (!getRedirectUrl(poll)) {
            return;
        }


        const canvas = document.querySelector(`#QR${pollCode}`);

        const backgroundColor = "#FFFFFF";

        const qrCodeWidth = canvas.width;
        const qrCodeHeight = canvas.height;

        const padding = 10;

        const newWidth = qrCodeWidth + 2 * padding;
        const newHeight = qrCodeHeight + 2 * padding;

        const newCanvas = document.createElement("canvas");
        newCanvas.width = newWidth;
        newCanvas.height = newHeight;
        const newContext = newCanvas.getContext("2d");

        newContext.fillStyle = backgroundColor;
        newContext.fillRect(0, 0, newWidth, newHeight);

        newContext.drawImage(canvas, padding, padding, qrCodeWidth, qrCodeHeight);

        const pngUrl = newCanvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");

        setQRCodeImageURL(pngUrl);
    }, []);

    if (!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC) {
        return (
            <YuJaTooltip
                text={SHARE_POLL_BUTTON_DISABLED_TOOLTIP_TEXT.replaceAll(
                    ACTIVITY_TYPE_PLACEHOLDER,
                    pollType === POLL_TYPE.ATTENDANCE
                        ? deCapitalizeWord(ATTENDANCE)
                        : deCapitalizeWord(POLL_TEXT)
                )}
                placement={"bottom"}
            >
                <div
                    tabIndex={0}
                    className={`${classes.smallBtn} ${classes.disabled}`}
                    style={{width: 85}}
                    data-yuja-share-trigger-id={randomId}
                >
                    <SHARED_ICON style={{marginRight: 7}}/>
                    {SHARE_TEXT}
                </div>
            </YuJaTooltip>
        );
    }


    return (
        <>
            <div
                tabIndex={0}
                className={`${classes.smallBtn} ${cardOpen ? classes.opened : ""}`}
                style={{width: 85}}
                data-yuja-share-trigger-id={randomId}
                onClick={() => setCardOpen(!cardOpen)}
            >
                <SHARED_ICON style={{marginRight: 7}}/>
                {SHARE_TEXT}
            </div>

            {!!getRedirectUrl(poll) &&
                <div
                    data-yuja-share-card-id={randomId}
                    className={classes.activityInfoCard}
                    style={{visibility: cardOpen ? "visible" : "hidden", width: 380, gap: 15, color: "#000"}}
                >
                    {(!poll.pollShareMode || poll.pollShareMode === POLL_SHARE_MODE.UNKNOWN) &&
                        <span className={classes.description}>
                            {pollType === POLL_TYPE.ATTENDANCE
                                ? "Remember to release your attendance after it is shared."
                                : "Remember to release your poll after it is shared."
                            }
                        </span>
                    }


                    <div className={classes.row}>
                        <COPY_LINK_ICON style={{marginRight: 7}}/>
                        <span>{pollType === POLL_TYPE.ATTENDANCE ? "Attendance Link" : "Poll Link"}</span>
                        <div style={{flex: 1}}/>
                        <CopyToClipboard
                            text={getRedirectUrl(poll)}
                            onCopy={() => notifySuccess(CLIPBOARD_COPY_SUCCESS.replace(UNIQUECODE_TEXT, pollType === POLL_TYPE.ATTENDANCE ? "Attendance Link" : "Poll Link"))}
                        >
                            <YuJaButton style={btnStyle}>
                                {pollType === POLL_TYPE.ATTENDANCE ? "Copy Attendance Link" : "Copy Poll Link"}
                            </YuJaButton>

                        </CopyToClipboard>


                    </div>
                    <div style={{borderTop: "1px solid #D1D1D1", width: "100%"}} />


                    <div className={classes.row}>
                        <div className={classes.column} style={{ gap: 10}}>
                            <div className={classes.row}>
                                <QR_ICON style={{marginRight: 7}}/>
                                <span>{"QR Code"}</span>
                            </div>

                            <div className={classes.QRContainer} style={{alignSelf: "center"}}>
                                <ImageViewer
                                    size={70}
                                    alt={"QR Code"}
                                    imageURL={QRCodeImageURL}
                                />


                                <QRCodeCanvas
                                    id={`QR${pollCode}`}
                                    size={512}
                                    renderAs="canvas"
                                    style={{display: "none",}}
                                    value={getRedirectUrl(poll)}
                                />
                            </div>

                            <span style={{color: "#717171"}}>{"Click to Enlarge"}</span>
                        </div>
                        <div style={{flex: 1}}/>

                        <YuJaButton style={btnStyle} onClick={downloadQR}>
                            {"Download QR Code"}
                        </YuJaButton>
                    </div>
                </div>
            }

            {!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED &&
                <div
                    data-yuja-share-card-id={randomId}
                    className={classes.activityInfoCard}
                    style={{visibility: cardOpen ? "visible" : "hidden", width: 350, gap: 15, color: "#000"}}
                >
                    <span className={classes.description}>
                        {NO_QR_CODE_OR_POLL_CODE_TO_SHARE
                            .replaceAll(
                                ACTIVITY_TYPE_PLACEHOLDER,
                                pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT
                            )
                            // + (` from ${poll.lmsHomeUrl}`)
                        }
                    </span>

                    <YuJaTooltip
                        text={!copied ? "" : COPIED_TEXT}
                        placement={"bottom"}
                        tooltipStyle={{maxWidth: 240}}
                        disabled={!copied}
                    >
                        <CopyToClipboard
                            text={!!poll.lmsCourseUrl ? poll.lmsCourseUrl : poll.lmsHomeUrl}
                            onMouseLeave={() => setCopied(false)}
                            onCopy={() => setCopied(true)}
                        >
                            <span className={classes.row} style={{lineHeight: 1.5, cursor: "pointer"}}>
                                <span style={{color: "#434343", fontSize: 15, fontWeight: "600", marginRight: 5}}>
                                    {LINK.charAt(0).toUpperCase() + LINK.slice(1)}:
                                </span>
                                <span className={classes.link} style={{flexShrink: 1, minWidth: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>
                                    {!!poll.lmsCourseUrl ? poll.lmsCourseUrl : poll.lmsHomeUrl}
                                </span>
                                <COPY_ICON style={{marginLeft: 5, flexShrink: 0}}/>
                            </span>
                        </CopyToClipboard>
                    </YuJaTooltip>
                </div>
            }
        </>
    );
}